import Vue from 'vue';
import Router from 'vue-router';

const _import = require('./_import_' + process.env.NODE_ENV);
import Full from '@/containers/Full'
import Page404 from '@/views/errorPages/Page404'
import Page500 from '@/views/errorPages/Page500'


const Login = _import('login/index');
Vue.use(Router);

export const constantRouterMap = [
    {
        path: '/login',
        component: Login,
        hidden: true
    },
    {
        path: '/pages',
        redirect: '/pages/p404',
        name: 'Pages',
        component: {
            render(c) {
                return c('router-view')
            }
        },
        children: [
            {
                path: '404',
                name: 'Page404',
                component: _import('errorPages/Page404')
            },
            {
                path: '500',
                name: 'Page500',
                component: _import('errorPages/Page404')
            },
        ]
    }
];

export default new Router({
    mode: 'hash',
    linkActiveClass: 'open active',
    scrollBehavior: () => ({y: 0}),
    routes: constantRouterMap
});

export const asyncRouterMap = [

    {
        path: '/',
        redirect: '/homePage',
        name: '首页',
        component: Full,
        hidden: false,
        children: [
            {
                path: '/homePage',
                name: '首页',
                icon: "ios-home-outline",
                component: _import('cms/HomePage'),
            },
            // {
            //     path: '/dashboard',
            //     name: 'Dashboard',
            //     icon: 'speedometer',
            //     component: _import('Dashboard')
            // },
            {
                path: '/hotwords',
                name: '热门搜索词',
                icon: "ios-flame-outline",
                component: _import('cms/HotWords')
            },
            {
                path: '/autoMessage',
                name: '自动回复',
                icon: 'ios-chatbubbles-outline',
                meta: {
                    name: "referrer",
                    content: 'no-referrer'
                },
                component: _import('autoMessage/MessageIndex')
            },
            {
                path: '/autoMessage/addMessage',
                name: '添加回复',
                hidden: true,
                meta: {
                    name: "referrer",
                    content: 'no-referrer'
                },
                component: _import('autoMessage/AddMessage')
            },
            {
                path: '/autoMessage/editMessage',
                name: '编辑回复',
                hidden: true,
                meta: {
                    name: "referrer",
                    content: 'no-referrer'
                },
                component: _import('autoMessage/EditMessage')
            },
            {
                path: '/wxMedia',
                name: '素材管理',
                icon: 'ios-images-outline',
                meta: {
                    name: "referrer",
                    content: 'no-referrer'
                },
                component: _import('autoMessage/WxMedia')
            },
            {
                path: '/charts',
                name: '统计图表',
                icon: "ios-trending-up",
                component: _import('charts/Chart'),
                children: [
                    {
                        path: 'userChart',
                        name: '用户统计',
                        component: _import('charts/UserChart')
                    },
                    {
                        path: 'shopChart',
                        name: '销售统计',
                        component: _import('charts/ShopChart')
                    },
                    {
                        path: 'inviteChart',
                        name: '邀请统计',
                        component: _import('charts/InviteChart')
                    }
                ]
            },
            {
                path: '/case',
                name: '案例管理',
                icon: "ios-briefcase-outline",
                component: _import('caseManage/CaseIndex'),
            },
            {
                path: '/categoryManage',
                name: '品类管理',
                icon: "ios-reorder",
                component: _import('categoryManage/CategoryIndex')
            },
            {
                path: '/brand',
                name: '品牌管理',
                icon: "ios-appstore-outline",
                component: _import('cms/Brand')
            },
            {
                path: '/activityGoods',
                name: '活动赠品管理',
                icon: "ios-appstore-outline",
                component: _import('activity/ActivityGoods')
            },
            {
                path: '/wechatAccount',
                name: '公众号管理',
                icon: "ios-person-outline",
                component: _import('cms/WechatAccount')
            },
            {
                path: '/catePage/:indexParent/:pageNum',
                name: '文章管理',
                icon: "ios-paper-outline",
                component: _import('cms/PageIndex')
            },
            {
                path: '/cate',
                name: '分类管理',
                icon: "ios-apps-outline",
                component: _import('cms/CateIndex')
            },
            {
                path: '/catePage/:indexParent/:pageNum/add/:indexParent',
                name: '添加文章',
                hidden: true,
                component: _import('cms/AddPage')
            },
            {
                path: '/catePage/:indexParent/:pageNum/edit/:indexId',
                name: '编辑文章',
                hidden: true,
                component: _import('cms/EditPage')
            },
            {
                path: '/company',
                name: '公司管理',
                icon: "ios-podium-outline",
                component: _import('cms/Company')
            },
            {
                path: '/platform',
                name: '平台管理',
                icon: "ios-book-outline",
                component: _import('cms/Platform')
            },
            {
                path: '/prize',
                name: '奖项管理',
                icon: "ios-trophy-outline",
                component: _import('cms/Prize')
            },
            {
                path: '/label',
                name: '标签管理',
                icon: "ios-flag-outline",
                component: _import('cms/Label')
            },
            {
                path: '/campaign',
                name: '战役管理',
                icon: "ios-football-outline",
                component: _import('cms/Campaign')
            },
            {
                path: '/order',
                name: '订单管理',
                icon: "ios-list",
                component: _import('cms/Order')
            },
            {
                path: '/guider',
                name: '导航管理',
                icon: "md-bulb",
                component: _import('guider/GuiderIndex')
            },
            {
                path: '/feedback',
                name: '案例反馈管理',
                icon: "ios-notifications-outline",
                component: _import('feedbackManage/FeedbackIndex')
            },
            {
                path: '/frontUser',
                name: '用户管理',
                icon: "ios-people-outline",
                component: _import('FrontUser')
            },
            {
                path: '/calendar',
                name: '日历管理',
                icon: "ios-clock-outline",
                component: _import('calendar/Calendar'),
                children: [

                   {
                        path: 'festivalRule',
                        name: '星期节日',
                        component: _import('calendar/FestivalRule')
                    },
                    {
                        path: 'festivalFixed',
                        name: '日期节日',
                        component: _import('calendar/FestivalFixed')
                    },
                    {
                        path: 'festivalType',
                        name: '节日标签',
                        component: _import('calendar/FestivalType')
                    }
                    /* {
                        path: 'identityAudit',
                        name: '身份审核',
                        component: _import('IdentityAudit/IdentityAudit'),
                    },
                    {
                        path: 'memberJoinDetail',
                        name: '会员加盟记录',
                        component: _import('MemberJoinList'),
                    },
                    {
                        path: 'memberAccountingDetail',
                        name: '会员分账明细',
                        hidden:true,
                        component: _import('MemeberAccountingList'),
                    }*/
                ]
            },
            {
                path: '/liveBroadCast',
                name: '直播管理',
                icon: "ios-videocam-outline",
                component: _import('LiveBroadCast/Live'),
                children: [

                    {
                        path: 'liveAntuorInfo',
                        name: '主播管理',
                        component: _import('LiveBroadCast/LiveAntuorInfo')
                    },
                    {
                        path: 'liveBroadCast',
                        name: '直播信息管理',
                        component: _import('LiveBroadCast/LiveBroadcast')
                    }
                ]
            },
            {
                path: '/caseScore',
                name: '评分管理',
                icon: "ios-stats-outline",
                component: _import('CaseScore/CaseScore'),
                children: [

                    {
                        path: 'caseScoreList',
                        name: '个人评分记录',
                        component: _import('CaseScore/caseScoreList')
                    },
                    {
                        path: 'caseScoreSum',
                        name: '案例评分总计',
                        component: _import('CaseScore/caseScoreSumList')
                    }
                ]
            },
            {
                path: '/userAuth',
                name: '认证管理',
                icon: "ios-checkmark-circle-outline",
                component: _import('userAuth/userAuth')
            },
            {
                path: '/userClaim',
                name: '认领管理',
                icon: "ios-checkbox-outline",
                component: _import('userClaim/userClaim')
            },
            {
                path: '/caseNavigation',
                name: '导航收藏管理',
                icon: "ios-star-outline",
                component: _import('CaseNavigation/caseNavigationList')
            },
            {
                path: '/authManagement',
                name: '权限组管理',
                icon: "ios-color-filter-outline",
                component: _import('authManage/AuthGroupList')
            },
            {
                path: '/adminUser',
                name: '后台用户管理',
                icon: "ios-contact-outline",
                component: _import('AdminUser')
            },
            // {
            //     path: '/frontUser',
            //     name: '前台用户管理',
            //     icon: "ios-people",
            //     component: _import('FrontUser')
            // },
            // ,
            // {
            //     path: '/editorContainer',
            //     name: '富文本容器',
            //     icon: "ios-contact",
            //     component: _import('components/upload/EditorContainer')
            // }
            //  ,
            //  {
            //      path: '/mutiPictures',
            //      name: '多图片上传组件',
            //      hidden: true,
            //      component: _import('components/upload/PictureUpload')
            //  },
            //  {
            //      path: '/fileUpload',
            //      name: '文件上传',
            //      hidden: true,
            //      component: _import('components/upload/FileUpload')
            //  },
            // {
            //      path: '/video',
            //      name: '视频上传组件',
            //      hidden: true,
            //      component: _import('components/upload/VideoUpload')
            //  },
            //  {
            //      path: '/richEditor',
            //      name: '富文本编辑器',
            //      hidden: true,
            //      component: _import('components/upload/RichEditor')
            //  },


            //  {
            //      path: '/introduction',
            //      name: '介绍',
            //      icon: 'thumbsup',
            //      component: _import('Introduction')
            //  },
            //  {
            //      path: '/components',
            //      name: 'component组件',
            //      redirect: '/components/buttons',
            //      icon: 'bookmark',
            //      component: {
            //          render(c) {
            //              return c('router-view')
            //          }
            //      },
            //      children: [
            //          {
            //              path: 'buttons',
            //              name: 'Buttons按钮',
            //              icon: 'social-youtube',
            //              component: _import('components/Buttons'),
            //              hidden: false,
            //          },
            //          {
            //              path: 'hoverbuttons',
            //              name: '悬停特效按钮',
            //              icon: 'wand',
            //              component: _import('components/HoverButtons')
            //          },
            //          {
            //              path: 'alert',
            //              name: 'Alert警告提示',
            //              icon: 'alert',
            //              component: _import('components/Alert')
            //          },
            //          {
            //              path: 'card',
            //              name: 'Card卡片',
            //              icon: 'ios-browsers-outline',
            //              component: _import('components/Card')
            //          },
            //          {
            //              path: 'datepicker',
            //              name: 'DatePicker',
            //              icon: 'ios-calendar-outline',
            //              component: _import('components/DatePicker')
            //          },
            //          {
            //              path: 'form',
            //              name: 'Form表单',
            //              icon: 'ios-list-outline',
            //              component: _import('components/Form')
            //          },
            //          {
            //              path: 'modal',
            //              name: 'Modal对话框',
            //              icon: 'ios-chatbubble-outline',
            //              component: _import('components/Modal')
            //          },
            //          {
            //              path: 'select',
            //              name: 'Select选择器',
            //              icon: 'ios-arrow-down',
            //              component: _import('components/Select')
            //          },
            //          {
            //              path: 'spin',
            //              name: 'Spin加载中',
            //              icon: 'load-d ',
            //              component: _import('components/Spin')
            //          },
            //          {
            //              path: 'steps',
            //              name: 'Steps步骤条',
            //              icon: 'ios-checkmark-outline',
            //              component: _import('components/Steps')
            //          },
            //          {
            //              path: 'timeline',
            //              name: 'Timeline时间轴',
            //              icon: 'android-more-vertical',
            //              component: _import('components/Timeline')
            //          },
            //          {
            //              path: 'transfer',
            //              name: 'Transfer穿梭框',
            //              icon: 'ios-pause-outline',
            //              component: _import('components/Transfer')
            //          },
            //          {
            //              path: 'timepicker',
            //              name: 'Timepicker',
            //              icon: 'ios-clock-outline',
            //              component: _import('components/Timepicker')
            //          },
            //          {
            //              path: 'upload',
            //              name: 'Upload上传',
            //              icon: 'ios-cloud-upload-outline',
            //              component: _import('components/Upload')
            //          },
            //      ]
            //  },
            //  {
            //      path: '/table',
            //      name: '表格综合实例',
            //      icon: 'ios-paper',
            //      component: _import('Table'),
            //      meta: {role: ['admin']}
            //  },
            //  {
            //      path: '/jsontree',
            //      name: 'JSON视图',
            //      icon: 'merge',
            //      component: _import('JsonTree')
            //  },
            //  {
            //      path: '/tabledetail/:id',
            //      name: 'TableDetail',
            //      hidden: true,
            //      component: _import('TableDetail')
            //  },
            //  {
            //      path: '/tinymce',
            //      name: 'Tinymce编辑器',
            //      icon: "android-document",
            //      component: _import('Tinymce')
            //  },
            //  {
            //      path: '/markdown',
            //      name: 'Markdown',
            //      icon: "android-list",
            //      component: _import('Markdown')
            //  },

        ]
    },
    {
        path: '*',
        redirect: '/pages/404',
        hidden: true
    }

];



// WEBPACK FOOTER //
// ./src/router/index.js